import * as c from '../constants';
import { onWaiting } from '../../Actions';

export const onSignUp = (success) => ({
    type: c.SIGNUP_SUCCESS,
    success
})

export const signUp = (data) => {
    return (dispatch, getState, { alert, api }) => {
        dispatch(onWaiting(true));
        api.post('/signup', data, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { success, message } = response;
                if(success) {
                    alert.success(message);
                    dispatch(onSignUp(success))
                }
            })
    }
}

const onGetSports = (data) => ({
    type: c.SIGNUP_SPORTS,
    data
})

export const getSports = () => {
    return (dispatch, getState, { api }) => {
        api.get('/sportslists')
            .then(response => {
                const { data } = response;
                dispatch(onGetSports(data))
            })
    }
}


// WEBPACK FOOTER //
// ./src/sign-up/actions/index.js